export const FLEET_ADMIN_ROLES = ["SUPER_ADMIN", "OPERATIONS_MANAGER"];
export const FLEET_TECH_ROLES = ["FIELD_TECH"];
export const FLEET_ROLES = [...FLEET_ADMIN_ROLES, ...FLEET_TECH_ROLES];

export const VEHICLE_TYPES = ["BIKE", "CAR", "VAN", "THREE_WHEEL", "OTHER"];
export const OWNERSHIP_TYPES = ["COMPANY_OWNED", "RENTED", "STAFF_OWNED_USED_FOR_WORK"];
export const VEHICLE_STATUSES = ["ACTIVE", "IN_REPAIR", "INACTIVE", "SOLD", "RETURNED_TO_OWNER"];
export const ASSIGNMENT_TYPES = ["PERMANENT", "TEMPORARY"];
export const MAINTENANCE_TYPES = ["SERVICE", "REPAIR"];

export const labelizeFleetValue = (value) =>
    String(value || "-")
        .replaceAll("_", " ")
        .toLowerCase()
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
